import 'browser/components/atomic-elements/atoms/list/_list.scss'
import { AbstractList, IAbstractListProps } from 'browser/components/atomic-elements/atoms/list/abstract-list'

export class List extends AbstractList<IAbstractListProps> {}
